<div class="session-attendance">
  <div class="sa-header">
    <div class="sa-title-row">
      <h2 class="sa-title">{{ setLabel('pageHeaderLabel') }}</h2>
      <button
        type="button"
        class="sa-refresh-btn"
        (click)="refresh()"
        [disabled]="loading"
      >
        <i class="pi pi-refresh" aria-hidden="true"></i>
        <span>{{ setLabel('refreshBtnLabel') }}</span>
      </button>
    </div>
    <div class="sa-nav">
      <button
        type="button"
        class="sa-nav-btn sa-nav-arrow"
        [attr.aria-label]="setLabel('prevDayBtnLabel')"
        [title]="setLabel('prevDayBtnLabel')"
        (click)="goPrevDay()"
        [disabled]="loading"
      >
        <i class="pi pi-chevron-left" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="sa-nav-btn"
        (click)="goToday()"
        [disabled]="loading"
      >
        {{ setLabel('todayBtnLabel') }}
      </button>
      <p-calendar
        styleClass="sa-cal"
        [(ngModel)]="selectedDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        [readonlyInput]="true"
        appendTo="body"
        (onSelect)="onCalendarSelect()"
        [disabled]="loading"
        [pTooltip]="setLabel('pickDateLabel')"
        tooltipPosition="top"
      ></p-calendar>
      <button
        type="button"
        class="sa-nav-btn sa-nav-arrow"
        [attr.aria-label]="setLabel('nextDayBtnLabel')"
        [title]="setLabel('nextDayBtnLabel')"
        (click)="goNextDay()"
        [disabled]="loading"
      >
        <i class="pi pi-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="sa-filters">
    <div class="sa-filter-group" *ngIf="showTrainerFilter">
      <span class="sa-filter-group-label">{{ setLabel('trainerFilterLabel') }}</span>
      <select
        class="sa-filter-dd"
        [value]="selectedTrainerId || ''"
        (change)="onTrainerSelect($any($event.target).value)"
      >
        <option value="">{{ setLabel('allTrainersLabel') }}</option>
        <option *ngFor="let t of trainerOptions" [value]="t.value">
          {{ t.label }}
        </option>
      </select>
    </div>

    <div class="sa-filter-group">
      <span class="sa-filter-group-label">{{
        setLabel('bookingScopeFilterLabel')
      }}</span>
      <div
        class="sa-type-filter"
        role="radiogroup"
        [attr.aria-label]="setLabel('bookingScopeFilterLabel')"
      >
        <label class="sa-filter-radio sa-filter-radio--booked">
          <input
            type="radio"
            name="saBookingScope"
            value="booked"
            [checked]="selectedBookingScope === 'booked'"
            (change)="selectedBookingScope = 'booked'"
          />
          <span class="sa-filter-dot" aria-hidden="true"></span>
          <span>{{ setLabel('bookedOnlyLabel') }}</span>
        </label>
        <label class="sa-filter-radio sa-filter-radio--all">
          <input
            type="radio"
            name="saBookingScope"
            value="all"
            [checked]="selectedBookingScope === 'all'"
            (change)="selectedBookingScope = 'all'"
          />
          <span class="sa-filter-dot" aria-hidden="true"></span>
          <span>{{ setLabel('allSlotsLabel') }}</span>
        </label>
      </div>
    </div>

    <div class="sa-filter-group">
      <span class="sa-filter-group-label">{{ setLabel('typeFilterLabel') }}</span>
      <div
        class="sa-type-filter"
        role="radiogroup"
        [attr.aria-label]="setLabel('typeFilterLabel')"
      >
        <label class="sa-filter-radio sa-filter-radio--all">
          <input
            type="radio"
            name="saTypeFilter"
            value="all"
            [checked]="selectedTypeFilter === 'all'"
            (change)="selectedTypeFilter = 'all'"
          />
          <span class="sa-filter-dot" aria-hidden="true"></span>
          <span>{{ setLabel('allTypesLabel') }}</span>
        </label>
        <label class="sa-filter-radio sa-filter-radio--one">
          <input
            type="radio"
            name="saTypeFilter"
            value="one_to_one"
            [checked]="selectedTypeFilter === 'one_to_one'"
            (change)="selectedTypeFilter = 'one_to_one'"
          />
          <span class="sa-filter-dot" aria-hidden="true"></span>
          <span>{{ setLabel('typeOneToOneLabel') }}</span>
        </label>
        <label class="sa-filter-radio sa-filter-radio--class">
          <input
            type="radio"
            name="saTypeFilter"
            value="class"
            [checked]="selectedTypeFilter === 'class'"
            (change)="selectedTypeFilter = 'class'"
          />
          <span class="sa-filter-dot" aria-hidden="true"></span>
          <span>{{ setLabel('typeClassLabel') }}</span>
        </label>
        <label class="sa-filter-radio sa-filter-radio--series">
          <input
            type="radio"
            name="saTypeFilter"
            value="program"
            [checked]="selectedTypeFilter === 'program'"
            (change)="selectedTypeFilter = 'program'"
          />
          <span class="sa-filter-dot" aria-hidden="true"></span>
          <span>{{ setLabel('typeProgramLabel') }}</span>
        </label>
      </div>
    </div>
  </div>

  <div class="sa-bootstrap" *ngIf="loading">
    <div class="sa-bootstrap-card">
      <div class="sa-bootstrap-spinner"></div>
      <p class="sa-bootstrap-title">{{ setLabel('loadingLabel') }}</p>
    </div>
  </div>

  <div class="sa-empty" *ngIf="!loading && !filteredRows.length">
    {{
      selectedBookingScope === 'booked'
        ? setLabel('emptyBookedDayLabel')
        : setLabel('emptyDayLabel')
    }}
  </div>

  <ul class="sa-list" *ngIf="!loading && filteredRows.length">
    <li
      class="sa-row"
      *ngFor="let s of filteredRows"
      [attr.data-type]="sessionTone(s)"
      [class.sa-row--one]="sessionTone(s) === 'one_to_one'"
      [class.sa-row--class]="sessionTone(s) === 'class'"
      [class.sa-row--series]="sessionTone(s) === 'program'"
      [class.is-clickable]="s.type === 'class'"
      (click)="s.type === 'class' ? openClassDialog(s) : null"
    >
      <div
        class="sa-session-meta"
      >
        <div class="sa-meta-col">
          <span class="sa-meta-label">{{ setLabel('trainerColLabel') }}</span>
          <span class="sa-meta-value" [title]="trainerName(s)">{{
            trainerName(s)
          }}</span>
        </div>
        <div class="sa-meta-col">
          <span class="sa-meta-label">{{ setLabel('typeColLabel') }}</span>
          <span
            class="sa-type-badge"
            [class.sa-type-badge--one]="sessionTone(s) === 'one_to_one'"
            [class.sa-type-badge--class]="sessionTone(s) === 'class'"
            [class.sa-type-badge--series]="sessionTone(s) === 'program'"
          >
            {{ sessionToneLabel(s) }}
          </span>
        </div>
        <div class="sa-meta-col">
          <span class="sa-meta-label">{{ setLabel('packageColLabel') }}</span>
          <span
            class="sa-meta-value sa-meta-value--pkg"
            [title]="packageName(s)"
            >{{ packageName(s) }}</span
          >
        </div>
        <div class="sa-meta-col">
          <span class="sa-meta-label">{{ setLabel('customerColLabel') }}</span>
          <span class="sa-meta-value" [title]="customerName(s)">{{
            customerName(s)
          }}</span>
        </div>
        <div class="sa-meta-col">
          <span class="sa-meta-label">{{ setLabel('timeColLabel') }}</span>
          <span class="sa-meta-value">{{ timeRange(s) }}</span>
        </div>
        <div class="sa-meta-col">
          <span class="sa-meta-label">{{ setLabel('seatsLabel') }}</span>
          <span class="sa-meta-value">{{ seatsDisplay(s) }}</span>
        </div>
      </div>

      <div
        class="sa-row-actions"
        (click)="$event.stopPropagation()"
      >
        <ng-container *ngIf="s.type === 'one_to_one'">
          <ng-container *ngIf="oneToOneBooking(s) as b">
            <span
              class="sa-status"
              *ngIf="b.status === 'Present' || b.status === 'Absent'"
              [attr.data-status]="b.status"
            >
              {{ statusLabel(b.status) }}
            </span>
            <button
              *ngIf="assessmentRequired && hasAssessment(b.customerId) && b.status !== 'confirmed'"
              type="button"
              class="sa-view-assessment"
              (click)="openAssessmentView(s, b)"
            >
              {{ setLabel('viewAssessmentBtnLabel') }}
            </button>
            <ng-container *ngIf="b.status === 'confirmed'">
              <button
                *ngIf="assessmentRequired && hasAssessment(b.customerId)"
                type="button"
                class="sa-view-assessment"
                (click)="openAssessmentView(s, b)"
              >
                {{ setLabel('viewAssessmentBtnLabel') }}
              </button>
              <button
                type="button"
                class="sa-mark-present"
                [disabled]="!canMark(b)"
                (click)="markPresent(s, b)"
              >
                {{ setLabel('markPresentBtnLabel') }}
              </button>
              <button
                type="button"
                class="sa-mark-noshow"
                [disabled]="!canMark(b)"
                (click)="markNoShow(b)"
              >
                {{ setLabel('markNoShowBtnLabel') }}
              </button>
              <small
  *ngIf="attendanceDisabledReason(b) as reason"
  style="display: block; color: #b45309; margin-top: 6px;"
>
  {{ reason }}
</small>
            </ng-container>
          </ng-container>
          <span class="sa-muted" *ngIf="!oneToOneBooking(s)">
            {{ setLabel('noBookingsLabel') }}
          </span>
        </ng-container>

        <button
          *ngIf="s.type === 'class'"
          type="button"
          class="sa-open-class-btn"
          [class.sa-open-class-btn--series]="sessionTone(s) === 'program'"
          (click)="openClassDialog(s)"
        >
          {{ setLabel('markAttendanceBtnLabel') }}
        </button>
      </div>
    </li>
  </ul>

  <div
    class="sa-class-dialog-backdrop"
    *ngIf="classDialogVisible"
    (click)="!classMarkBusy && closeClassDialog()"
  >
    <div
      class="sa-class-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="classDialogHeaderLabel()"
      [class.sa-class-dialog--series]="sessionTone(classSession) === 'program'"
      (click)="$event.stopPropagation()"
    >
      <div class="sa-class-dialog-header">
        <h3 class="sa-class-dialog-title">
          {{ classDialogHeaderLabel() }}
        </h3>
        <button
          type="button"
          class="sa-class-dialog-x"
          (click)="closeClassDialog()"
          [disabled]="classMarkBusy"
          [attr.aria-label]="setLabel('closeBtnLabel')"
        >
          ×
        </button>
      </div>

      <div class="sa-class-dialog-body" *ngIf="classSession as cs">
        <div class="sa-dialog-toolbar">
          <div class="sa-dialog-meta-block">
            <p class="sa-dialog-meta">
              <strong>{{ timeRange(cs) }}</strong> · {{ packageName(cs) }}
            </p>
            <p class="sa-hint">{{ setLabel('classMembersHintLabel') }}</p>
          </div>
          <button
            type="button"
            class="sa-mark-attendance-btn"
            [disabled]="!classPendingCount || classMarkBusy"
            (click)="markClassAttendance()"
          >
            {{ setLabel('markAttendanceBtnLabel') }}
            <span *ngIf="classPendingCount">({{ classPendingCount }})</span>
          </button>
        </div>

        <div class="sa-empty" *ngIf="!cs.bookings?.length">
          {{ setLabel('noBookingsLabel') }}
        </div>

        <ul class="sa-member-list" *ngIf="cs.bookings?.length">
          <li class="sa-member-row" *ngFor="let b of cs.bookings">
            <div class="sa-member-info">
              <span class="sa-member-name">{{
                b.customerName || setLabel('memberColLabel')
              }}</span>
              <span
                class="sa-status"
                *ngIf="b.status === 'Present' || b.status === 'Absent'"
                [attr.data-status]="b.status"
              >
                {{ statusLabel(b.status) }}
              </span>
              <button
                *ngIf="assessmentRequired && hasAssessment(b.customerId) && classSession && b.status !== 'confirmed'"
                type="button"
                class="sa-view-assessment"
                (click)="openAssessmentView(classSession, b)"
              >
                {{ setLabel('viewAssessmentBtnLabel') }}
              </button>
            </div>

            <div class="sa-member-checks" *ngIf="b.status === 'confirmed'">
              <button
                *ngIf="assessmentRequired && hasAssessment(b.customerId) && classSession"
                type="button"
                class="sa-view-assessment"
                (click)="openAssessmentView(classSession, b)"
              >
                {{ setLabel('viewAssessmentBtnLabel') }}
              </button>
              <label
                class="sa-check sa-check--present"
                [class.is-on]="classMarkOf(b) === 'Present'"
                [title]="setLabel('markPresentBtnLabel')"
              >
                <input
                  type="checkbox"
                  [checked]="classMarkOf(b) === 'Present'"
                  [disabled]="!canMark(b)"
                  (change)="
                    setClassMark(b, 'Present', $any($event.target).checked)
                  "
                />
                <span class="sa-check-box" aria-hidden="true"></span>
                <span class="sa-check-label">{{
                  setLabel('markPresentBtnLabel')
                }}</span>
              </label>
              <label
                class="sa-check sa-check--absent"
                [class.is-on]="classMarkOf(b) === 'Absent'"
                [title]="setLabel('markNoShowBtnLabel')"
              >
                <input
                  type="checkbox"
                  [checked]="classMarkOf(b) === 'Absent'"
                  [disabled]="!canMark(b)"
                  (change)="
                    setClassMark(b, 'Absent', $any($event.target).checked)
                  "
                />
                <span class="sa-check-box" aria-hidden="true"></span>
                <span class="sa-check-label">{{
                  setLabel('markNoShowBtnLabel')
                }}</span>
              </label>
              <small
  *ngIf="attendanceDisabledReason(b) as reason"
  style="display: block; color: #b45309; margin-top: 6px;"
>
  {{ reason }}
</small>
            </div>
          </li>
        </ul>
      </div>

      <div class="sa-class-dialog-footer">
        <button
          type="button"
          class="sa-dialog-close"
          (click)="closeClassDialog()"
          [disabled]="classMarkBusy"
        >
          {{ setLabel('closeBtnLabel') }}
        </button>
      </div>
    </div>
  </div>

  <p-dialog
    styleClass="sa-assessment-dialog"
    appendTo="body"
    [showHeader]="false"
    [(visible)]="assessmentVisible"
    [modal]="true"
    [style]="{ width: '98vw', height: '96vh' }"
    [contentStyle]="{ height: '100%', padding: '0', overflow: 'hidden' }"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeAssessment()"
  >
    <div class="sa-assessment" *ngIf="assessmentForm as form">
      <header class="sa-dash-head">
        <div class="sa-dash-title">
          <span class="sa-dash-mark"><i class="pi pi-heart"></i></span>
          <strong>{{ setLabel('assessmentTitleLabel') }}</strong>
        </div>
        <button type="button" class="sa-dash-x" (click)="closeAssessment()" [disabled]="assessmentSaving" [attr.aria-label]="setLabel('closeBtnLabel')">
          <i class="pi pi-times"></i>
        </button>
      </header>
      <div class="sa-summary">
        <div class="sa-summary-who">
          <span class="sa-avatar"><i class="pi pi-user"></i></span>
          <div>
            <strong>{{ form.clientName || form.answers.client.fullName }}</strong>
            <span class="sa-badge">{{ setLabel('memberFallbackLabel') }}</span>
          </div>
        </div>
        <div class="sa-summary-date">
          <i class="pi pi-calendar"></i>
          <div>
            <span>{{ setLabel('assessmentSignedOnLabel') }}</span>
            <strong>{{ form.signedOn || '—' }}</strong>
          </div>
        </div>
      </div>
      <div class="sa-grid-scroll">
      <div class="sa-grid">
      <section class="sa-sec">
        <h4><span class="sa-num">1</span><span>{{ setLabel('assessmentClientLabel') }}</span><i class="pi pi-user"></i></h4>
        <div class="sa-sec-body sa-split sa-split-3">
        <label>{{ setLabel('assessmentFullNameLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.fullName" /></label>
        <label>{{ setLabel('assessmentDobLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.dateOfBirth" placeholder="YYYY-MM-DD" /></label>
        <label>{{ setLabel('assessmentAgeLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.age" /></label>
        <div class="sa-q sa-span">
          <span>{{ setLabel('assessmentGenderLabel') }}</span>
          <div class="sa-opts">
            <label class="sa-check" *ngFor="let opt of ['Male','Female','Other']">
              <input type="checkbox" [checked]="form.answers.client.gender === opt" (change)="setChoice(form.answers.client, 'gender', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" />
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
        <label>{{ setLabel('assessmentPhoneLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.phone" /></label>
        <label>{{ setLabel('assessmentEmailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.email" /></label>
        <label class="sa-span">{{ setLabel('assessmentAddressLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.address" /></label>
        <label>{{ setLabel('assessmentOccupationLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.occupation" /></label>
        <label>{{ setLabel('assessmentEmergencyNameLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.emergencyName" /></label>
        <label class="sa-field">{{ setLabel('assessmentEmergencyPhoneLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.client.emergencyPhone" /></label>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">2</span><span>{{ setLabel('assessmentGoalsLabel') }}</span><i class="pi pi-flag"></i></h4>
        <div class="sa-sec-body">
        <p class="sa-q-title">What are your primary goals? Tick all that apply.</p>
        <div class="sa-checks">
        <label class="sa-check" *ngFor="let goal of ['Fat Loss','Muscle Gain','Improve Strength','Improve Endurance','Better Health & Fitness','Athletic Performance','Improve Body Composition','Other']">
          <input type="checkbox" [disabled]="assessmentReadOnly" [checked]="goalChecked(goal)" (change)="toggleGoal(goal, $any($event.target).checked)" />
          <span>{{ goal }}</span>
        </label>
        </div>
        <label>{{ setLabel('assessmentOtherLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.goals.other" /></label>
        <label>{{ setLabel('assessmentTargetDateLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.goals.targetDate" /></label>
        <label class="sa-field">{{ setLabel('assessmentMotivationLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.goals.motivation" /></label>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">3</span><span>{{ setLabel('assessmentLifestyleLabel') }}</span><i class="pi pi-heart"></i></h4>
        <div class="sa-sec-body">
        <label class="sa-field">{{ setLabel('assessmentDaysPerWeekLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.lifestyle.daysPerWeek" /></label>
        <div class="sa-q">
          <span>{{ setLabel('assessmentSleepLabel') }}</span>
          <div class="sa-opts">
            <label class="sa-check" *ngFor="let opt of ['<5','5-6','7-8','8+ hrs']">
              <input type="checkbox" [checked]="form.answers.lifestyle.sleepBand === opt" (change)="setChoice(form.answers.lifestyle, 'sleepBand', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" />
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
        <label class="sa-field">{{ setLabel('assessmentStressLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.lifestyle.stressLevel" placeholder="1-10" /></label>
        <div class="sa-q">
          <span>{{ setLabel('assessmentWorkTypeLabel') }}</span>
          <div class="sa-opts">
            <label class="sa-check" *ngFor="let opt of ['Sedentary','Light','Moderate','Physical']">
              <input type="checkbox" [checked]="form.answers.lifestyle.workType === opt" (change)="setChoice(form.answers.lifestyle, 'workType', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" />
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
        <div class="sa-q">
          <span>{{ setLabel('assessmentSpecificDietLabel') }}</span>
          <div class="sa-opts">
            <label class="sa-check" *ngFor="let opt of ['Yes','No']">
              <input type="checkbox" [checked]="form.answers.lifestyle.specificDiet === opt" (change)="setChoice(form.answers.lifestyle, 'specificDiet', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" />
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
        <label class="sa-field" *ngIf="form.answers.lifestyle.specificDiet === 'Yes'">{{ setLabel('assessmentDietDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.lifestyle.dietDetail" /></label>
        <div class="sa-q">
          <span>{{ setLabel('assessmentSmokesLabel') }}</span>
          <div class="sa-opts">
            <label class="sa-check" *ngFor="let opt of ['Yes','No']">
              <input type="checkbox" [checked]="form.answers.lifestyle.smokes === opt" (change)="setChoice(form.answers.lifestyle, 'smokes', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" />
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
        <div class="sa-q">
          <span>{{ setLabel('assessmentAlcoholLabel') }}</span>
          <div class="sa-opts">
            <label class="sa-check" *ngFor="let opt of ['Yes','No']">
              <input type="checkbox" [checked]="form.answers.lifestyle.alcohol === opt" (change)="setChoice(form.answers.lifestyle, 'alcohol', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" />
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
        <label class="sa-field">{{ setLabel('assessmentWaterLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.lifestyle.waterIntake" /></label>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">4</span><span>{{ setLabel('assessmentMedicalLabel') }}</span><i class="pi pi-plus"></i></h4>
        <div class="sa-sec-body">
        <div class="sa-q"><span>{{ setLabel('assessmentConditionsLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.medical.conditions === opt" (change)="setChoice(form.answers.medical, 'conditions', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label>{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.medical.conditionsDetail" /></label>
        <div class="sa-q"><span>{{ setLabel('assessmentInjuriesLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.medical.injuries === opt" (change)="setChoice(form.answers.medical, 'injuries', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label>{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.medical.injuriesDetail" /></label>
        <div class="sa-q"><span>{{ setLabel('assessmentMedicationLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.medical.medication === opt" (change)="setChoice(form.answers.medical, 'medication', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label>{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.medical.medicationDetail" /></label>
        <div class="sa-q"><span>{{ setLabel('assessmentAllergiesLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.medical.allergies === opt" (change)="setChoice(form.answers.medical, 'allergies', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label class="sa-field">{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.medical.allergiesDetail" /></label>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">5</span><span>{{ setLabel('assessmentTrainingLabel') }}</span><i class="pi pi-replay"></i></h4>
        <div class="sa-sec-body">
        <div class="sa-q"><span>{{ setLabel('assessmentTrainedBeforeLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.training.trainedBefore === opt" (change)="setChoice(form.answers.training, 'trainedBefore', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label class="sa-field" *ngIf="form.answers.training.trainedBefore === 'Yes'">{{ setLabel('assessmentHowLongLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.training.howLong" /></label>
        <p class="sa-q-title">{{ setLabel('assessmentTrainingTypesLabel') }}</p>
        <div class="sa-checks">
        <label class="sa-check" *ngFor="let kind of ['Weight Training','Cardio','Functional','Sports','Other']">
          <input type="checkbox" [disabled]="assessmentReadOnly" [checked]="trainingTypeChecked(kind)" (change)="toggleTrainingType(kind, $any($event.target).checked)" />
          <span>{{ kind }}</span>
        </label>
        </div>
        <div class="sa-q">
          <span>{{ setLabel('assessmentLevelLabel') }}</span>
          <div class="sa-opts">
            <label class="sa-check" *ngFor="let opt of ['Beginner','Intermediate','Advanced']">
              <input type="checkbox" [checked]="form.answers.training.level === opt" (change)="setChoice(form.answers.training, 'level', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" />
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
        <label class="sa-field">{{ setLabel('assessmentChallengesLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.training.challenges" /></label>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">6</span><span>{{ setLabel('assessmentMeasurementsLabel') }}</span><i class="pi pi-chart-bar"></i></h4>
        <div class="sa-sec-body">
        <div class="sa-measure sa-measure-head"><span>Measurement</span><span>Current</span><span>Goal</span></div>
        <div class="sa-measure"><span>Weight (kg)</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.weight.current" /><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.weight.goal" /></div>
        <div class="sa-measure"><span>Height (cm / ft)</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.height.current" /><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.height.goal" /></div>
        <div class="sa-measure"><span>Waist (cm)</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.waist.current" /><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.waist.goal" /></div>
        <div class="sa-measure"><span>Hips (cm)</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.hips.current" /><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.hips.goal" /></div>
        <div class="sa-measure"><span>Chest (cm)</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.chest.current" /><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.chest.goal" /></div>
        <div class="sa-measure"><span>Arms (cm)</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.arms.current" /><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.arms.goal" /></div>
        <div class="sa-measure"><span>Thighs (cm)</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.thighs.current" /><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.measurements.thighs.goal" /></div>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">8</span><span>{{ setLabel('assessmentPostureLabel') }}</span><i class="pi pi-users"></i></h4>
        <div class="sa-sec-body">
        <div class="sa-q"><span>{{ setLabel('assessmentPostureIssuesLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.posture.issues === opt" (change)="setChoice(form.answers.posture, 'issues', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label>{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.posture.issuesDetail" /></label>
        <div class="sa-q"><span>{{ setLabel('assessmentLimitationsLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.posture.limitations === opt" (change)="setChoice(form.answers.posture, 'limitations', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label>{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.posture.limitationsDetail" /></label>
        <p class="sa-q-title">Check if any of the following are noticeable</p>
        <div class="sa-checks">
        <label class="sa-check" *ngFor="let flag of ['Forward head','Rounded shoulders','Uneven hips','Knee alignment issues','Flat back','Other']">
          <input type="checkbox" [disabled]="assessmentReadOnly" [checked]="listChecked('posture','flags',flag)" (change)="toggleList('posture','flags',flag,$any($event.target).checked)" />
          <span>{{ flag }}</span>
        </label>
        </div>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">9</span><span>{{ setLabel('assessmentTestsLabel') }}</span><i class="pi pi-chart-line"></i></h4>
        <div class="sa-sec-body">
        <div class="sa-measure sa-measure-head sa-two"><span>Test</span><span>Result</span></div>
        <div class="sa-measure sa-two"><span>{{ setLabel('assessmentPushUpsLabel') }}</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.tests.pushUps" /></div>
        <div class="sa-measure sa-two"><span>{{ setLabel('assessmentSquatLabel') }}</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.tests.squat" /></div>
        <div class="sa-measure sa-two"><span>{{ setLabel('assessmentPlankLabel') }}</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.tests.plank" /></div>
        <div class="sa-measure sa-two"><span>{{ setLabel('assessmentRunWalkLabel') }}</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.tests.runWalk" /></div>
        <div class="sa-measure sa-two"><span>{{ setLabel('assessmentFlexibilityLabel') }}</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.tests.flexibility" /></div>
        <div class="sa-measure sa-two"><span>{{ setLabel('assessmentGripLabel') }}</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.tests.grip" /></div>
        <div class="sa-measure sa-two"><span>{{ setLabel('assessmentOtherLabel') }}</span><input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.tests.other" /></div>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">10</span><span>{{ setLabel('assessmentNutritionLabel') }}</span><i class="pi pi-apple"></i></h4>
        <div class="sa-sec-body">
        <label>{{ setLabel('assessmentMealsLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.nutrition.mealsPerDay" /></label>
        <div class="sa-q"><span>{{ setLabel('assessmentTracksMacrosLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.nutrition.tracksMacros === opt" (change)="setChoice(form.answers.nutrition, 'tracksMacros', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <div class="sa-q"><span>{{ setLabel('assessmentDietTypeLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Vegetarian','Non-vegetarian','Vegan','Other']"><input type="checkbox" [checked]="form.answers.nutrition.dietType === opt" (change)="setChoice(form.answers.nutrition, 'dietType', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <div class="sa-q"><span>{{ setLabel('assessmentIntolerancesLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.nutrition.intolerances === opt" (change)="setChoice(form.answers.nutrition, 'intolerances', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label class="sa-field" *ngIf="form.answers.nutrition.intolerances === 'Yes'">{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.nutrition.intolerancesDetail" /></label>
        <div class="sa-q"><span>{{ setLabel('assessmentHydrationLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Poor','Fair','Good','Excellent']"><input type="checkbox" [checked]="form.answers.nutrition.hydration === opt" (change)="setChoice(form.answers.nutrition, 'hydration', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">11</span><span>{{ setLabel('assessmentExtraLabel') }}</span><i class="pi pi-info-circle"></i></h4>
        <div class="sa-sec-body">
        <div class="sa-q"><span>{{ setLabel('assessmentPreferencesLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Yes','No']"><input type="checkbox" [checked]="form.answers.extra.preferences === opt" (change)="setChoice(form.answers.extra, 'preferences', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label>{{ setLabel('assessmentDetailLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.extra.preferencesDetail" /></label>
        <div class="sa-q"><span>{{ setLabel('assessmentEnvironmentLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Gym','Home','Both']"><input type="checkbox" [checked]="form.answers.extra.environment === opt" (change)="setChoice(form.answers.extra, 'environment', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        <label class="sa-field">{{ setLabel('assessmentCommentsLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.extra.comments" /></label>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">13</span><span>{{ setLabel('assessmentProgramLabel') }}</span><i class="pi pi-calendar"></i></h4>
        <div class="sa-sec-body">
        <label>{{ setLabel('assessmentShortTermLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.program.shortTerm" /></label>
        <label>{{ setLabel('assessmentMidTermLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.program.midTerm" /></label>
        <label>{{ setLabel('assessmentLongTermLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.program.longTerm" /></label>
        <label>{{ setLabel('assessmentFrequencyLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.program.frequencyDays" /></label>
        <p class="sa-q-title">Session focus</p>
        <div class="sa-checks">
        <label class="sa-check" *ngFor="let focus of ['Strength','Hypertrophy','Conditioning','Other']">
          <input type="checkbox" [disabled]="assessmentReadOnly" [checked]="listChecked('program','focus',focus)" (change)="toggleList('program','focus',focus,$any($event.target).checked)" />
          <span>{{ focus }}</span>
        </label>
        </div>
        <div class="sa-q"><span>{{ setLabel('assessmentPreferredTimeLabel') }}</span><div class="sa-opts"><label class="sa-check" *ngFor="let opt of ['Morning','Afternoon','Evening']"><input type="checkbox" [checked]="form.answers.program.preferredTime === opt" (change)="setChoice(form.answers.program, 'preferredTime', opt, $any($event.target).checked)" [disabled]="assessmentReadOnly" /><span>{{ opt }}</span></label></div></div>
        </div>
      </section>
      <section class="sa-sec">
        <h4><span class="sa-num">14</span><span>{{ setLabel('assessmentProgressLabel') }}</span><i class="pi pi-chart-line"></i></h4>
        <div class="sa-sec-body sa-split">
        <label>{{ setLabel('assessmentReviewDateLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.progress.reviewDate" /></label>
        <label>{{ setLabel('assessmentNextCheckInLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.progress.nextCheckIn" /></label>
        <label class="sa-span">{{ setLabel('assessmentNotesLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.progress.notes" /></label>
        <label>{{ setLabel('assessmentClientSignLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.clientName" /></label>
        <label>{{ setLabel('assessmentSignedOnLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.progress.clientDate" /></label>
        <label>{{ setLabel('assessmentTrainerSignLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.trainerName" /></label>
        <label>{{ setLabel('assessmentSignedOnLabel') }}<input [readonly]="assessmentReadOnly" [(ngModel)]="form.answers.progress.trainerDate" /></label>
        </div>
      </section>
      </div>
      </div>
      <footer class="sa-dash-foot">
        <div class="sa-sheet-brand">
          <div class="sa-bty">
            <span>Better</span>
            <span>Than</span>
            <span>Yesterday</span>
          </div>
          <div class="sa-club">
            <strong>{{ assessmentGymName }}</strong>
            <small>TRAIN | TRANSFORM | ACHIEVE</small>
          </div>
        </div>
        <div class="sa-assessment-actions">
          <button type="button" class="sa-download" *ngIf="assessmentReadOnly" (click)="downloadAssessment()">{{ setLabel('assessmentDownloadLabel') }}</button>
          <button type="button" class="sa-close" (click)="closeAssessment()" [disabled]="assessmentSaving">{{ setLabel('closeBtnLabel') }}</button>
          <button type="button" class="sa-mark-present" *ngIf="!assessmentReadOnly" (click)="saveAssessment()" [disabled]="assessmentSaving">{{ setLabel('assessmentSaveLabel') }}</button>
        </div>
      </footer>
    </div>
  </p-dialog>
</div>
